(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["weekender-gallery"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.__wkgGallery) return;
    window.__wkgGallery = true;

    var reduce = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var mouse = window.matchMedia ? window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 990px)') : null;
    function still() { return !!(reduce && reduce.matches); }
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    /* Shuffle (data-wkg-shuffle): one random order for the wall, grid,
       thumbnails and photo data. Runs before the lightbox reads the data. */
    var WALL_WIDTHS = [360, 540, 720, 900, 1100];
    function sized(src, w) { return src.replace(/([?&])width=\d+/, '$1width=' + w); }
    function shuffle(root) {
      if (!root.hasAttribute('data-wkg-shuffle')) return;
      var dataEl = root.querySelector('[data-wkg-data]');
      var grid = root.querySelector('[data-wkg-gridview]');
      var strip = root.querySelector('[data-wkg-thumbs]');
      if (!dataEl || !grid || !strip) return;
      var photos = [];
      try { photos = JSON.parse(dataEl.textContent); } catch (e) { return; }
      var n = photos.length;
      var gridItems = Array.prototype.slice.call(grid.children);
      var thumbItems = Array.prototype.slice.call(strip.children);
      if (n < 2 || gridItems.length !== n || thumbItems.length !== n) return;

      var order = photos.map(function (_, i) { return i; });
      for (var i = n - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = order[i]; order[i] = order[j]; order[j] = t;
      }

      function renumber(li, to, label) {
        var btn = li.querySelector('[data-wkg-open]');
        if (btn) {
          btn.setAttribute('data-wkg-open', to + 1);
          btn.setAttribute('aria-label', label + (to + 1) + ' of ' + n);
        }
        var no = li.querySelector('.wkg__grid-no');
        if (no) no.textContent = pad(to + 1);
      }
      order.forEach(function (from, to) {
        var g = gridItems[from];
        g.style.setProperty('--i', to);
        renumber(g, to, 'Open photo ');
        grid.appendChild(g);
        renumber(thumbItems[from], to, 'Photo ');
        strip.appendChild(thumbItems[from]);
      });

      // Wall prints keep their slot (tilt, sticker, "+N more") and swap photo.
      var tag = root.getAttribute('data-wkg-tag') || '';
      root.querySelectorAll('[data-wkg-wall] .wkg__card').forEach(function (card, k) {
        var p = photos[order[k]];
        var img = card.querySelector('.wkg__frame img');
        if (!p || !img) return;
        img.srcset = WALL_WIDTHS.map(function (w) { return sized(p.src, w) + ' ' + w + 'w'; }).join(', ');
        img.src = sized(p.src, 1100);
        img.width = p.w;
        img.height = p.h;
        img.alt = p.alt;
        img.style.objectPosition = p.pos || 'center';
        var cap = card.querySelector('.wkg__cap');
        if (cap) cap.textContent = p.caption || tag;
        var btn = card.querySelector('[data-wkg-open]');
        if (btn) btn.setAttribute('aria-label', 'Open photo ' + (k + 1) + ' of ' + n + (p.caption ? ': ' + p.caption : ''));
      });

      dataEl.textContent = JSON.stringify(order.map(function (from) { return photos[from]; }));
    }

    /* Toss-in: .is-in once per [data-wkg-reveal] at 20% in view; .is-visible
       on the section while any of it is on screen (loops pause otherwise). */
    function reveal(root) {
      if (still() || !('IntersectionObserver' in window)) return;
      root.classList.add('wkg--anim');
      var enter = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); enter.unobserve(e.target); }
        });
      }, { threshold: 0.2 });
      root.querySelectorAll('[data-wkg-reveal]').forEach(function (el) { enter.observe(el); });
      new IntersectionObserver(function (entries) {
        root.classList.toggle('is-visible', entries[entries.length - 1].isIntersecting);
      }).observe(root);
    }

    /* Carousel (<990px): mark the centred print, drive the progress bar. */
    function carousel(root) {
      var wall = root.querySelector('[data-wkg-wall]');
      if (!wall) return;
      var cards = wall.querySelectorAll('.wkg__card');
      var bar = root.querySelector('[data-wkg-progress]');
      var pos = root.querySelector('[data-wkg-pos]');
      var queued = false;
      function update() {
        queued = false;
        var mid = wall.getBoundingClientRect().left + wall.clientWidth / 2;
        var best = 0;
        var bestD = Infinity;
        cards.forEach(function (c, i) {
          var r = c.getBoundingClientRect();
          var d = Math.abs(r.left + r.width / 2 - mid);
          if (d < bestD) { bestD = d; best = i; }
        });
        cards.forEach(function (c, i) { c.classList.toggle('is-centre', i === best); });
        if (bar) bar.style.transform = 'scaleX(' + (best + 1) / cards.length + ')';
        if (pos) pos.textContent = pad(best + 1) + ' / ' + pad(cards.length);
      }
      function queue() { if (!queued) { queued = true; requestAnimationFrame(update); } }
      wall.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
      update();
    }

    /* Desktop: a "View" chip that follows the mouse over the prints. */
    function cursor(root) {
      var chip = root.querySelector('[data-wkg-cursor]');
      var wall = root.querySelector('[data-wkg-wall]');
      if (!chip || !wall || !mouse) return;
      root.classList.add('wkg--cursor');
      var x = 0;
      var y = 0;
      var queued = false;
      function place() {
        queued = false;
        var r = root.getBoundingClientRect();
        chip.style.translate = (x - r.left) + 'px ' + (y - r.top) + 'px';
      }
      wall.addEventListener('pointermove', function (e) {
        if (e.pointerType !== 'mouse' || !mouse.matches) return;
        x = e.clientX;
        y = e.clientY;
        var t = e.target.closest('[data-wkg-open],[data-wkg-all]');
        var label = t && t.hasAttribute('data-wkg-all') ? 'See all' : 'View';
        if (chip.textContent !== label) chip.textContent = label;
        chip.classList.toggle('is-on', !!t);
        if (!queued) { queued = true; requestAnimationFrame(place); }
      });
      wall.addEventListener('pointerleave', function () { chip.classList.remove('is-on'); });
      window.addEventListener('scroll', function () {
        if (chip.classList.contains('is-on') && !queued) { queued = true; requestAnimationFrame(place); }
      }, { passive: true });
    }

    /* Full-screen grid + single-photo viewer with its own URL. */
    function lightbox(root) {
      var dialog = root.querySelector('[data-wkg-dialog]');
      var dataEl = root.querySelector('[data-wkg-data]');
      if (!dialog || !dataEl) return;
      var photos = [];
      try { photos = JSON.parse(dataEl.textContent); } catch (e) { return; }
      if (!photos.length) return;

      var anchor = root.getAttribute('data-wkg-anchor');
      var gridView = dialog.querySelector('[data-wkg-gridview]');
      var single = dialog.querySelector('[data-wkg-single]');
      var stage = dialog.querySelector('[data-wkg-stage]');
      var big = dialog.querySelector('[data-wkg-big]');
      var caption = dialog.querySelector('[data-wkg-caption]');
      var status = dialog.querySelector('[data-wkg-status]');
      var backBtn = dialog.querySelector('[data-wkg-grid]');
      var strip = dialog.querySelector('[data-wkg-thumbs]');
      var thumbs = dialog.querySelectorAll('[data-wkg-thumb]');
      var unit = photos.length === 1 ? ' photo' : ' photos';
      var current = 0;
      var opener = null;
      var direct = false;   // opened straight onto a photo: Esc closes instead of showing the grid
      var token = 0;

      function setHash(h) {
        var url = location.pathname + location.search + (h ? '#' + h : '');
        history.replaceState(history.state, '', url);
      }

      function preload(i) {
        var p = photos[(i + photos.length) % photos.length];
        if (p) { var img = new Image(); img.sizes = '100vw'; img.srcset = p.srcset; img.src = p.src; }
      }

      function showPhoto(n, dir) {
        current = (n - 1 + photos.length) % photos.length;
        var p = photos[current];
        var t = ++token;
        gridView.hidden = true;
        single.hidden = false;
        backBtn.hidden = false;

        big.classList.add('is-reset');
        big.classList.remove('is-ready', 'is-drag');
        big.style.transform = '';
        big.style.setProperty('--dir', still() ? 0 : (dir || 0));
        void big.offsetWidth;
        big.classList.remove('is-reset');
        stage.classList.add('is-loading');

        big.sizes = '100vw';
        big.srcset = p.srcset;
        big.src = p.src;
        big.alt = p.alt || '';
        big.width = p.w;
        big.height = p.h;
        caption.textContent = p.caption || '';
        status.textContent = pad(current + 1) + ' / ' + pad(photos.length);

        thumbs.forEach(function (b, i) {
          if (i !== current) { b.removeAttribute('aria-current'); return; }
          b.setAttribute('aria-current', 'true');
          strip.scrollTo({ left: b.parentNode.offsetLeft - (strip.clientWidth - b.offsetWidth) / 2, behavior: still() ? 'auto' : 'smooth' });
        });

        function ready() {
          if (t !== token) return;
          stage.classList.remove('is-loading');
          big.classList.add('is-ready');
        }
        if (big.decode) big.decode().then(ready, ready);
        else if (big.complete) ready();
        else big.onload = big.onerror = ready;

        setHash(anchor + '/' + (current + 1));
        preload(current + 1);
        preload(current - 1);
      }

      function step(dir) { showPhoto(current + 1 + dir, dir); }

      function showGrid() {
        direct = false;
        token++;
        single.hidden = true;
        gridView.hidden = false;
        backBtn.hidden = true;
        status.textContent = photos.length + unit;
        setHash(anchor);
        var btn = gridView.querySelector('[data-wkg-open="' + (current + 1) + '"]');
        if (btn) btn.focus();
      }

      function open(n) {
        var wasOpen = dialog.open;
        if (!wasOpen) {
          opener = document.activeElement;
          direct = !!n;
          dialog.showModal();
          document.documentElement.style.overflow = 'hidden';
        }
        if (n) {
          var dir = wasOpen && !single.hidden ? (n - 1 > current ? 1 : n - 1 < current ? -1 : 0) : 0;
          showPhoto(n, dir);
        } else {
          current = 0;
          showGrid();
          dialog.scrollTop = 0;
          if (!still()) {
            gridView.classList.remove('is-in');
            void gridView.offsetWidth;
            gridView.classList.add('is-in');
          }
        }
      }

      function close() { if (dialog.open) dialog.close(); }

      dialog.addEventListener('close', function () {
        token++;
        document.documentElement.style.overflow = '';
        setHash('');
        if (opener && opener.focus) opener.focus({ preventScroll: true });
      });

      root.addEventListener('click', function (e) {
        var t = e.target.closest('[data-wkg-open],[data-wkg-all],[data-wkg-step],[data-wkg-close],[data-wkg-grid]');
        if (!t || !root.contains(t)) return;
        e.preventDefault();
        if (t.hasAttribute('data-wkg-open')) open(parseInt(t.getAttribute('data-wkg-open'), 10));
        else if (t.hasAttribute('data-wkg-all')) open(0);
        else if (t.hasAttribute('data-wkg-step')) step(parseInt(t.getAttribute('data-wkg-step'), 10));
        else if (t.hasAttribute('data-wkg-grid')) showGrid();
        else close();
      });

      dialog.addEventListener('keydown', function (e) {
        if (single.hidden) return;
        if (e.key === 'ArrowRight') { e.preventDefault(); step(1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); step(-1); }
        else if (e.key === 'Escape' && !direct) { e.preventDefault(); showGrid(); }
      });

      /* Drag / swipe: the photo follows the finger (or mouse), flicks on release. */
      var drag = null;
      stage.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 || e.target.closest('button')) return;
        drag = { id: e.pointerId, x: e.clientX, y: e.clientY, dx: 0, on: false };
      });
      stage.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        drag.dx = e.clientX - drag.x;
        if (!drag.on) {
          if (Math.abs(drag.dx) < 8) return;
          if (Math.abs(e.clientY - drag.y) > Math.abs(drag.dx)) { drag = null; return; }
          drag.on = true;
          if (stage.setPointerCapture) stage.setPointerCapture(e.pointerId);
          big.classList.add('is-drag');
        }
        big.style.transform = 'translateX(' + drag.dx + 'px) rotate(' + (drag.dx / 40) + 'deg)';
      });
      function endDrag(e) {
        if (!drag || e.pointerId !== drag.id) return;
        var d = drag;
        drag = null;
        big.classList.remove('is-drag');
        if (!d.on) return;
        if (Math.abs(d.dx) > 60) step(d.dx < 0 ? 1 : -1);
        else big.style.transform = '';
      }
      stage.addEventListener('pointerup', endDrag);
      stage.addEventListener('pointercancel', endDrag);

      function fromHash() {
        var h = decodeURIComponent(location.hash.slice(1));
        if (h === anchor) open(0);
        else if (h.indexOf(anchor + '/') === 0) {
          var n = parseInt(h.slice(anchor.length + 1), 10);
          if (n >= 1 && n <= photos.length) open(n);
        }
      }
      window.addEventListener('hashchange', fromHash);
      fromHash();
    }

    function init(root) {
      if (root.__wkg) return;
      root.__wkg = true;
      shuffle(root);
      reveal(root);
      carousel(root);
      cursor(root);
      lightbox(root);
    }

    function initAll() { document.querySelectorAll('[data-wkg]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
    document.addEventListener('shopify:block:select', function (e) {
      var card = e.target.closest && e.target.closest('.wkg__card');
      if (card) card.scrollIntoView({ block: 'nearest', inline: 'center' });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
